// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_selections.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Facets } from "../../search/v1/facet";
import { AccessReviewSelectionRef } from "./accessreview";
import { AccessReviewSelectionState } from "./accessreview";
import { Any } from "../../../../google/protobuf/any";
import { AccessReviewSelectionView } from "./accessreview";
import { AccessReviewSelectionExpandMask } from "./accessreview";
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceListRequest
 */
export interface AccessReviewSelectionsServiceListRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSelectionExpandMask expand_mask = 4;
     */
    expandMask?: AccessReviewSelectionExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceListResponse
 */
export interface AccessReviewSelectionsServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSelectionView list = 1;
     */
    list: AccessReviewSelectionView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceAddRequest
 */
export interface AccessReviewSelectionsServiceAddRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated string entitlement_ids = 3;
     */
    entitlementIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceAddResponse
 */
export interface AccessReviewSelectionsServiceAddResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchRequest
 */
export interface AccessReviewSelectionsSearchServiceSearchRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string exclude_ids = 5;
     */
    excludeIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSelectionState selection_states = 6;
     */
    selectionStates: AccessReviewSelectionState[];
    /**
     * @generated from protobuf field: repeated string application_ids = 7;
     */
    applicationIds: string[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSelectionExpandMask expand_mask = 8;
     */
    expandMask?: AccessReviewSelectionExpandMask;
    /**
     * @generated from protobuf field: repeated string risk_level_ids = 9;
     */
    riskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string compliance_framework_ids = 10;
     */
    complianceFrameworkIds: string[];
    /**
     * @generated from protobuf field: repeated string data_type_ids = 11;
     */
    dataTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string data_classification_ids = 12;
     */
    dataClassificationIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSelectionRef refs = 13;
     */
    refs: AccessReviewSelectionRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchResponse
 */
export interface AccessReviewSelectionsSearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSelectionView list = 1;
     */
    list: AccessReviewSelectionView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 4;
     */
    facets?: Facets;
}
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionsServiceListRequest$Type extends MessageType<AccessReviewSelectionsServiceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionsServiceListRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewSelectionExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceListRequest
 */
export const AccessReviewSelectionsServiceListRequest = new AccessReviewSelectionsServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionsServiceListResponse$Type extends MessageType<AccessReviewSelectionsServiceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionsServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSelectionView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceListResponse
 */
export const AccessReviewSelectionsServiceListResponse = new AccessReviewSelectionsServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionsServiceAddRequest$Type extends MessageType<AccessReviewSelectionsServiceAddRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionsServiceAddRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceAddRequest
 */
export const AccessReviewSelectionsServiceAddRequest = new AccessReviewSelectionsServiceAddRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionsServiceAddResponse$Type extends MessageType<AccessReviewSelectionsServiceAddResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionsServiceAddResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionsServiceAddResponse
 */
export const AccessReviewSelectionsServiceAddResponse = new AccessReviewSelectionsServiceAddResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionsSearchServiceSearchRequest$Type extends MessageType<AccessReviewSelectionsSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "exclude_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "selection_states", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AccessReviewSelectionState", AccessReviewSelectionState, "ACCESS_REVIEW_SELECTION_STATE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 7, name: "application_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "expand_mask", kind: "message", T: () => AccessReviewSelectionExpandMask },
            { no: 9, name: "risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 10, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 11, name: "data_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 12, name: "data_classification_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 13, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSelectionRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchRequest
 */
export const AccessReviewSelectionsSearchServiceSearchRequest = new AccessReviewSelectionsSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionsSearchServiceSearchResponse$Type extends MessageType<AccessReviewSelectionsSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSelectionView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchResponse
 */
export const AccessReviewSelectionsSearchServiceSearchResponse = new AccessReviewSelectionsSearchServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewSelectionsService
 */
export const AccessReviewSelectionsService = new ServiceType("c1.api.accessreview.v1.AccessReviewSelectionsService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSelectionsServiceListRequest, O: AccessReviewSelectionsServiceListResponse },
    { name: "Add", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewSelectionsServiceAddRequest, O: AccessReviewSelectionsServiceAddResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewSelectionsSearchService
 */
export const AccessReviewSelectionsSearchService = new ServiceType("c1.api.accessreview.v1.AccessReviewSelectionsSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewSelectionsSearchServiceSearchRequest, O: AccessReviewSelectionsSearchServiceSearchResponse }
]);
